"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JINN_GAMES = exports.GAMES_SEARCH = exports.GAMES = exports.UPLOAD_MY_DOCUMENTS = exports.REMOVE_MY_DOCUMENTS = exports.GET_MY_DOCUMENTS_PAYMENT = exports.GET_MY_DOCUMENTS_ADDRESS = exports.GET_MY_DOCUMENTS_IDENTITY = exports.PAY_OUT_MAKE = exports.PAY_OUT_METHODS = exports.PAY_IN_GET_DETAILS = exports.PAY_IN_REPEAT_MAKE = exports.PAY_IN_MAKE = exports.PAY_IN_PROFILE_METHODS = exports.PUBLIC_PAY_IN_METHODS = exports.PAY_IN_METHODS = exports.DEPOSIT_MAKE = exports.DEPOSIT_METHODS = exports.COUNTRIES = exports.CURRENCIES = exports.ACTIVATE_PROMOCODE = exports.PROMO_BY_CODE = exports.MY_FREESPINS_HISTORY = exports.CANCEL_FREESPINS_BONUS = exports.ACTIVATE_FREESPINS_BONUS = exports.MY_FREESPINS = exports.BONUS_PHONE_VERIFICATION = exports.MY_BONUSES_HISTORY = exports.PROMOTIONS = exports.LOYALTY_BONUSES = exports.PROMOTIONS_BY_PROMOCODE = exports.BONUSES_BY_PROMOCODE = exports.AFFILIATE_BONUS = exports.BONUSES_BY_TYPE = exports.ALL_BONUSES = exports.ACTIVATE_BONUS = exports.CANCEL_BONUS = exports.MY_BONUSES = exports.GET_GLP = exports.WITHDRAWAL_BALANCE = exports.ALL_BALANCES = exports.BALANCE = exports.VERIFY_CODE = exports.SIGN_OUT = exports.SET_NEW_PASSWORD_WITH_TOKEN = exports.SET_NEW_PASSWORD = exports.FORGOT_PASSWORD_RESET = exports.SIGN_UP = exports.LOGIN = exports.globalStateKeys = void 0;
exports.GET_BET_LIMITS = exports.DELETE_LOSS_LIMITS = exports.SET_LOSS_LIMITS = exports.GET_LOSS_LIMITS = exports.DELETE_DEPOSIT_LIMITS = exports.SET_DEPOSIT_LIMITS = exports.GET_DEPOSIT_LIMITS = exports.WITHDRAWAL_ENABLED = exports.WITHDRAWAL_METHODS = exports.WITHDRAWAL_CANCEL = exports.WITHDRAWAL_MAKE = exports.GET_RECENT_GAMES = exports.REMOVE_FAVORITE_GAME = exports.ADD_FAVORITE_GAME = exports.GET_FAVORITE_GAMES = exports.USER_REFERRAL_CODE = exports.UPDATE_PASSWORD = exports.UPDATE_PROFILE_DATA = exports.USER_KYC = exports.UPDATE_RECEIVE_PROMOS = exports.USER = exports.DEPOSIT_SUCCESS_COUNT = exports.PENDING_DEPOSITS = exports.PENDING_WITHDRAWALS = exports.PROFILE_LAST_DEPOSIT_TRANSACTION = exports.PROFILE_TRANSACTIONS_HISTORY = exports.TRANSACTIONS = exports.TOURNAMENTS_JOIN = exports.TOURNAMENTS_FINISHED = exports.TOURNAMENTS_CURRENT = exports.TOURNAMENTS_STATIC = exports.TOURNAMENTS = exports.TOURNAMENT_SCORES = exports.GET_PROVIDERS_SEARCH = exports.GET_PROVIDERS = exports.GET_PROVIDER_PAGE = exports.MY_LEVEL_PROGRESS = exports.ALL_LEVELS = exports.GEO_DATA = exports.GAME_FREESPINS = exports.LAST_WINNERS = exports.SLOT_OF_THE_WEEK_INFO = exports.GAME_INFO = exports.GAME_REPORT = exports.GAME_URL = exports.GAMES_RECOMMENDATIONS_BY_CATEGORIES = exports.GAMES_RECOMMENDATIONS = exports.GAMES_ROUNDS = exports.GAMES_CATEGORIES = exports.GAMES_BY_PROVIDER = void 0;
exports.GET_REFERRAL_WIDGET = exports.GET_BETTING_HISTORY = exports.BETTING_SESSION_STATUS = exports.BETTING_SESSION_CREATE = exports.GET_CONFIG = exports.REPORT_COMMON_ERROR = exports.VERIFY_EMAIL = exports.REQUEST_VERIFY_EMAIL = exports.is_EMAIL_VERIFICATION_ENABLED = exports.TEXTS_PROMOTIONS = exports.TEXTS = exports.GET_LOTTERY_TICKETS_HISTORY = exports.GET_LOTTERY_REWARDS = exports.GET_LOTTERIES = exports.VERIFY_PHONE_BY_CODE = exports.SEND_PHONE_VERIFICATION_SMS = exports.IS_PHONE_VERIFICATION_ENABLED = exports.JACKPOT_TOTAL = exports.MAKE_SPIN = exports.GET_PUBLIC_WHEEL = exports.GET_VIP_WHEEL = exports.GET_WHEEL = exports.GET_MANAGER = exports.TRANSLATIONS = exports.CLOSE_SESSION = exports.SET_COOL_OFF_LIMITS = exports.GET_COOL_OFF_LIMITS = exports.DELETE_SESSION_LIMITS = exports.SET_SESSION_LIMITS = exports.GET_SESSION_LIMITS = exports.DELETE_BET_LIMITS = exports.SET_BET_LIMITS = void 0;
// Global State Keys
exports.globalStateKeys = {
    HELP_DESK_OPEN: 'helpDeskOpen',
    USER_TYPE: 'userType',
    PAYMENT_TYPE: 'paymentType',
    DEPOSIT_CURRENT_BONUS: 'depositCurrentBonus',
    TEXT: 'text',
};
//AUTH
exports.LOGIN = '/api/auth/login';
exports.SIGN_UP = '/api/auth/signup';
exports.FORGOT_PASSWORD_RESET = '/api/auth/forgot-password';
exports.SET_NEW_PASSWORD = '/api/auth/set-new-password';
exports.SET_NEW_PASSWORD_WITH_TOKEN = '/api/auth/set-new-password-with-token';
exports.SIGN_OUT = '/api/auth/signout';
exports.VERIFY_CODE = '/api/auth/verify-code';
//BALANCE
exports.BALANCE = '/api/balance/current';
exports.ALL_BALANCES = '/api/balance/get-all-balances';
exports.WITHDRAWAL_BALANCE = '/api/balance/withdrawal-balance';
//GLP
exports.GET_GLP = '/api/glp';
//BONUSES
exports.MY_BONUSES = '/api/bonuses/my';
exports.CANCEL_BONUS = '/api/bonuses/cancel';
exports.ACTIVATE_BONUS = '/api/bonuses/activate';
exports.ALL_BONUSES = '/api/bonuses/all';
exports.BONUSES_BY_TYPE = '/api/bonuses/by-type';
exports.AFFILIATE_BONUS = '/api/bonuses/affiliate';
exports.BONUSES_BY_PROMOCODE = '/api/bonuses/by-promocode';
exports.PROMOTIONS_BY_PROMOCODE = '/api/bonuses/promotions/by-promocode';
exports.LOYALTY_BONUSES = '/api/bonuses/loyalty';
exports.PROMOTIONS = '/api/bonuses/promotions';
exports.MY_BONUSES_HISTORY = '/api/bonuses/history';
exports.BONUS_PHONE_VERIFICATION = '/api/bonuses/phone-verification';
//FREESPINS
exports.MY_FREESPINS = '/api/bonuses/freespins';
exports.ACTIVATE_FREESPINS_BONUS = '/api/bonuses/freespins/activate';
exports.CANCEL_FREESPINS_BONUS = '/api/bonuses/freespins/cancel';
exports.MY_FREESPINS_HISTORY = '/api/bonuses/freespins/history';
// PROMOCODES
exports.PROMO_BY_CODE = '/api/promocodes/get-by-code';
exports.ACTIVATE_PROMOCODE = '/api/promocodes/activate';
//CURRENCIES
exports.CURRENCIES = '/api/currencies';
//COUNTRIES
exports.COUNTRIES = '/api/countries';
//DEPOSIT
exports.DEPOSIT_METHODS = '/api/deposit/methods';
exports.DEPOSIT_MAKE = '/api/deposit/make';
//PAY IN
exports.PAY_IN_METHODS = '/api/pay-in/methods';
exports.PUBLIC_PAY_IN_METHODS = '/api/pay-in/public-methods';
exports.PAY_IN_PROFILE_METHODS = '/api/pay-in/profile-methods';
exports.PAY_IN_MAKE = '/api/pay-in/make';
exports.PAY_IN_REPEAT_MAKE = '/api/pay-in/make-repeat';
exports.PAY_IN_GET_DETAILS = '/api/pay-in/details';
//PAY OUT
exports.PAY_OUT_METHODS = '/api/pay-out/methods';
exports.PAY_OUT_MAKE = '/api/pay-out/make';
//DOCUMENTS
exports.GET_MY_DOCUMENTS_IDENTITY = '/api/documents/my?type=identity';
exports.GET_MY_DOCUMENTS_ADDRESS = '/api/documents/my?type=address';
exports.GET_MY_DOCUMENTS_PAYMENT = '/api/documents/my?type=payment';
exports.REMOVE_MY_DOCUMENTS = '/api/documents/remove';
exports.UPLOAD_MY_DOCUMENTS = '/api/documents/upload';
//GAMES
exports.GAMES = '/api/games';
exports.GAMES_SEARCH = '/api/games/search';
exports.JINN_GAMES = '/api/games/jinn';
exports.GAMES_BY_PROVIDER = '/api/games/provider';
exports.GAMES_CATEGORIES = '/api/games/categories';
exports.GAMES_ROUNDS = '/api/games/rounds';
exports.GAMES_RECOMMENDATIONS = '/api/games/recommendations';
exports.GAMES_RECOMMENDATIONS_BY_CATEGORIES = '/api/games/recommendations/by-categories';
exports.GAME_URL = '/api/game/url';
exports.GAME_REPORT = '/api/game/report';
exports.GAME_INFO = '/api/game/info';
exports.SLOT_OF_THE_WEEK_INFO = '/api/game/game-week';
exports.LAST_WINNERS = '/api/games/last-winners';
exports.GAME_FREESPINS = '/api/games/freespins';
//GEO
exports.GEO_DATA = '/api/geo';
//LOYALTY
exports.ALL_LEVELS = '/api/loyalty/levels';
exports.MY_LEVEL_PROGRESS = '/api/loyalty/progress';
//PAGES
exports.GET_PROVIDER_PAGE = '/api/pages/provider';
//PROVIDERS
exports.GET_PROVIDERS = '/api/providers';
exports.GET_PROVIDERS_SEARCH = '/api/providers/search';
//TOURNAMENTS
exports.TOURNAMENT_SCORES = '/api/tournaments/scores';
exports.TOURNAMENTS = '/api/tournaments';
exports.TOURNAMENTS_STATIC = '/api/tournaments-static';
exports.TOURNAMENTS_CURRENT = '/api/tournaments/current';
exports.TOURNAMENTS_FINISHED = '/api/tournaments/finished';
exports.TOURNAMENTS_JOIN = '/api/tournaments/join';
//TRANSACTIONS
exports.TRANSACTIONS = '/api/transactions';
exports.PROFILE_TRANSACTIONS_HISTORY = '/api/transactions/history';
exports.PROFILE_LAST_DEPOSIT_TRANSACTION = "".concat(exports.PROFILE_TRANSACTIONS_HISTORY, "?scope=last-deposit");
exports.PENDING_WITHDRAWALS = '/api/transactions/pending-withdrawals';
exports.PENDING_DEPOSITS = '/api/transactions/pending-deposits';
exports.DEPOSIT_SUCCESS_COUNT = '/api/transactions/deposit-count';
//USER
exports.USER = '/api/user';
exports.UPDATE_RECEIVE_PROMOS = '/api/user/receive-promos';
exports.USER_KYC = '/api/user/kyc';
exports.UPDATE_PROFILE_DATA = '/api/user/update';
exports.UPDATE_PASSWORD = '/api/user/update-password';
exports.USER_REFERRAL_CODE = '/api/user/referral-code';
//USER GAMES
exports.GET_FAVORITE_GAMES = '/api/user-games/get-favorites';
exports.ADD_FAVORITE_GAME = '/api/user-games/add-favorite';
exports.REMOVE_FAVORITE_GAME = '/api/user-games/remove-favorite';
exports.GET_RECENT_GAMES = '/api/user-games/get-recent';
//WITHDRAWAL
exports.WITHDRAWAL_MAKE = '/api/withdrawal/make';
exports.WITHDRAWAL_CANCEL = '/api/withdrawal/cancel';
exports.WITHDRAWAL_METHODS = '/api/withdrawal/methods';
exports.WITHDRAWAL_ENABLED = '/api/withdrawal/enabled';
//LIMITS
exports.GET_DEPOSIT_LIMITS = '/api/limits/deposit/get';
exports.SET_DEPOSIT_LIMITS = '/api/limits/deposit/set';
exports.DELETE_DEPOSIT_LIMITS = '/api/limits/deposit/delete';
exports.GET_LOSS_LIMITS = '/api/limits/loss/get';
exports.SET_LOSS_LIMITS = '/api/limits/loss/set';
exports.DELETE_LOSS_LIMITS = '/api/limits/loss/delete';
exports.GET_BET_LIMITS = '/api/limits/bet/get';
exports.SET_BET_LIMITS = '/api/limits/bet/set';
exports.DELETE_BET_LIMITS = '/api/limits/bet/delete';
exports.GET_SESSION_LIMITS = '/api/limits/session/get';
exports.SET_SESSION_LIMITS = '/api/limits/session/set';
exports.DELETE_SESSION_LIMITS = '/api/limits/session/delete';
exports.GET_COOL_OFF_LIMITS = '/api/limits/cooling-off/get';
exports.SET_COOL_OFF_LIMITS = '/api/limits/cooling-off/set';
exports.CLOSE_SESSION = '/api/session/close';
//TRANSLATIONS
exports.TRANSLATIONS = '/api/translations';
//MANAGER
exports.GET_MANAGER = '/api/manager/get';
//WHEEL
exports.GET_WHEEL = '/api/wheel/get';
exports.GET_VIP_WHEEL = '/api/wheel/get-vip';
exports.GET_PUBLIC_WHEEL = '/api/wheel/get-public';
exports.MAKE_SPIN = '/api/spin/make';
//JACKPOT
exports.JACKPOT_TOTAL = '/api/jackpot/total';
//PHONE
exports.IS_PHONE_VERIFICATION_ENABLED = '/api/phone/verification/enabled';
exports.SEND_PHONE_VERIFICATION_SMS = '/api/phone/verification/send-sms';
exports.VERIFY_PHONE_BY_CODE = '/api/phone/verification/verify';
//LOTTERY
exports.GET_LOTTERIES = '/api/lottery/get';
exports.GET_LOTTERY_REWARDS = '/api/lottery/rewards/get';
exports.GET_LOTTERY_TICKETS_HISTORY = '/api/lottery/tickets/get';
//TEXTS
exports.TEXTS = '/api/texts';
exports.TEXTS_PROMOTIONS = '/api/texts/promotions';
// EMAIL
exports.is_EMAIL_VERIFICATION_ENABLED = '/api/email/verification/enabled';
exports.REQUEST_VERIFY_EMAIL = '/api/email/verification/request-verify';
exports.VERIFY_EMAIL = '/api/email/verification/verify';
// REPORT
exports.REPORT_COMMON_ERROR = '/api/report/common';
// CONFIG
exports.GET_CONFIG = '/api/config';
// BETTING
exports.BETTING_SESSION_CREATE = '/api/betting/session/create';
exports.BETTING_SESSION_STATUS = '/api/betting/session/status';
exports.GET_BETTING_HISTORY = '/api/betting/bets';
//REFERRAL
exports.GET_REFERRAL_WIDGET = '/api/referral-widget';
